import styled from "styled-components";

export const Main = styled.main`
    display: block;
    flex: 1;
    width: 100%;
    height: calc(100% - 73px);

    h1{
        position: absolute; 
        top: 0; 
        font-size: 1.2rem; 
        background: var(--darkblue); 
        color: #fff;
        padding: 15px;
        width: 100%;
    }

    .wform{
        width: 40%;
        padding-top: 80px;
        padding-bottom: 150px;
        margin: 0 auto;
        max-width: 650px;
        min-width: 250px;
    }

    hr{ border-top: dashed rgba(0,0,0,0.3) 1px; height: 0; margin: 13px 0 12px 0}

    label{
        opacity: 0.9;
        font-size: 0.7rem;
        padding: 9px 17px;
        display: inline-block;
    }
    .flex{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    strong{
        font-size:  0.8rem;
        margin-right: 8px;
    }
`

export const Thumb = styled.div`
    width: 8rem;
    height: 8rem;
    margin: 0 auto 20px auto;
    overflow: hidden;    
    min-width: 8rem;

    img{
        border-radius: 50%;
        width: 100%;
        height: 100%;
    }
`